declare var $:any;
import { Component, ViewChild,OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonService } from '../shared/common.service';
import { BrowserModule, Title } from '@angular/platform-browser';
import * as alertFunctions from '../shared/data/sweet-alerts';
import { AuthenticationService } from '../_services';
import { first } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [CommonService]
})
export class LoginComponent implements OnInit {

  public LoginType: string = "";
  public showPasswordField: Boolean = false;
  public UserId: String = "";
  public Password: String = "";
  public patientmobilenumber: string = "";
  public UserOTP: Number;
  public showPassword: boolean = false;

  @ViewChild('f') loginForm: NgForm;
  constructor(private titleService: Title, private router: Router, private route: ActivatedRoute, private http: CommonService, private authenticationService: AuthenticationService) {
     
    this.authenticationService.loggedUser = false;
    
    this.titleService.setTitle("Login")
  }

  ngOnInit() {  
    
    sessionStorage.setItem('refcode', '');
    sessionStorage.setItem('MobileNo', '');
    sessionStorage.setItem('welcomeUserName', '');

    sessionStorage.setItem('EntityGuid', '');
    sessionStorage.setItem('ExternalClientId', '');
    sessionStorage.setItem('VisitId', '');
    sessionStorage.setItem('VisitDate', '');
    sessionStorage.setItem('PatientId', '');
    sessionStorage.setItem('PtCode', '');
    window.localStorage.removeItem("LogoutUser");

    this.route.queryParams.subscribe((params: any) => {

      this.LoginType = params.type;
      sessionStorage.setItem("LoginType", this.LoginType);

    });

    if (this.LoginType == "" || this.LoginType == undefined || this.LoginType == null) {
        this.LoginType = "patient";
        sessionStorage.setItem("LoginType", this.LoginType);
    }

    sessionStorage.setItem("refcode", "");
    sessionStorage.setItem("MobileNo", "");
    sessionStorage.setItem("Branch_User", "");
    sessionStorage.setItem("Super_User", "");

    var headersmartreport = document.getElementById("headersmartreport");
    // headersmartreport.style.display = 'none'; 

  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
 
  Login() {
    
    if (this.UserId == '' || this.UserId == undefined || this.UserId == null) {
      alertFunctions.typeError('Username/Password is missing');
      return false;
    }

    if (this.Password == "" || this.Password == undefined || this.Password == null) {
      alertFunctions.typeError("Username/Password is missing");
      return false;
    }
    if ($('#customCheckboxlogin').is(':checked') != true) {
      alertFunctions.typeError("Please accept the disclaimer ");
      return false;
    }
    var item = {
      "userId": this.UserId.trim(),
      "password": this.Password.trim(),
      "mobileNumber": "",
      "otp": ""
    }

    this.authenticationService.login(item)
    .pipe(first())
    .subscribe((data: any) => {     
      if (data["code"] == "200") {
        sessionStorage.setItem("refcode", this.UserId.toString().trim());                           
        sessionStorage.setItem("Branch_User", data["Branch_User"]);
        sessionStorage.setItem("Super_User", data["Super_User"]);
        sessionStorage.setItem("welcomeUserName", data["welcomeUserName"]); 
        //document.getElementById("user").innerHTML = data["welcomeUserName"];       
        this.router.navigate(["visitgrid"])
        .then(() => {
          window.location.reload();
        });
      }
      else {
        alertFunctions.typeError(data["message"]);
      }
    });
  }

  continueButtonClick() {
    if (this.showPasswordField && (this.UserOTP == 0 || this.UserOTP == undefined || this.UserOTP == null)) {
      alertFunctions.typeError("Please enter the valid OTP");
      return false;
    }

    if (this.showPasswordField && $('#customCheckboxInline1').is(':checked') != true) {
      alertFunctions.typeError("Please accept the disclaimer");

      return false;
    }

    if (!this.showPasswordField && (this.patientmobilenumber== "" || this.patientmobilenumber== null ||  this.patientmobilenumber== undefined)) {
      alertFunctions.typeError("Please enter the valid Phone Number");

      return false;
    }

    var item = {
      "userId": "",
      "password": "",
      "mobileNumber": this.patientmobilenumber.trim(),
      "otp": this.showPasswordField ? this.UserOTP : ""
    }

    this.authenticationService.login(item)
    .pipe(first())
    .subscribe((data: any) => {
      
      if (data["code"] == "200") {
        if (this.showPasswordField) {
          sessionStorage.setItem("MobileNo", this.patientmobilenumber.toString());
          sessionStorage.setItem("Branch_User", "0");
          sessionStorage.setItem("Super_User", "0");
          sessionStorage.setItem("welcomeUserName", data["PatientName"]); 
          this.router.navigate(["visitgriddetails"])
          .then(() => {
            window.location.reload();
          });
        } 
        this.showPasswordField = true;       
      }
      else {
        alertFunctions.typeError(data["message"]);
      }
    });
  }


  changeEmailOrMobile() {
    this.showPasswordField = false;
  }

}
